/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    DATABASE_STATISTICS_SERVICE
 * Date:         2026-01-XX
 * Modified By:  Cursor
 *
 * Description:
 * Service for fetching database statistics - MongoDB collection stats (count and size).
 *
 * File Size Check:
 * - Current: 0 lines (new file)
 * - Adding: ~55 lines
 * - Projected: ~55 lines
 * - Decision: Proceed
 *
 * Related Screens / Modules:
 * - client/src/pages/admin/DatabaseStatisticsPage.tsx
 * - server/controllers/admin/databaseStatisticsController.js
 */

import axios from 'axios';
import { getAuthHeaders } from '../../utils/authUtils';
import { config } from '../../config/environment';

const API_URL = config.apiUrl;

export interface CollectionStat {
  name: string;
  count: number;
  size: number; // Size in KB
  error?: string;
}

export interface DatabaseStatisticsResponse {
  success: boolean;
  data: {
    collections: CollectionStat[];
    totalCollections: number;
    totalDocuments: number;
    totalSize: number; // Total size in KB
  };
}

/**
 * Get database statistics for all MongoDB collections
 * [2026-01-XX] Database stats: Fetch dynamically discovered collections
 */
export async function getDatabaseStatistics(): Promise<DatabaseStatisticsResponse> {
  try {
    const response = await axios.get<DatabaseStatisticsResponse>(
      `${API_URL}/api/admin/database-statistics`,
      {
        headers: getAuthHeaders().headers
      }
    );
    return response.data;
  } catch (error: any) {
    console.error('Failed to fetch database statistics:', error);
    throw error;
  }
}
